import { IValidateReportCsvResponse } from "@shared/lib/types/reports";
import { TextWithTooltip } from "@shared/ui/TextWithTooltip";
import { AlertCircle, CheckCircle } from "lucide-react";
import styles from "../styles.module.scss";

interface ReviewStepProps {
  fileName: string;
  results: IValidateReportCsvResponse[];
}

export function ReviewStep({ fileName, results }: ReviewStepProps) {
  const successCount = results.filter((r) => r.status === "success").length;
  const failedCount = results.filter((r) => r.status === "failed").length;

  return (
    <div className={styles.reviewContainer}>
      <div className={styles.reviewHeader}>
        <div className={styles.reviewBanner}>
          <CheckCircle size={18} className={styles.successIcon} />
          <span className={styles.reviewBannerText}>
            File "{fileName}" parsed
          </span>
          <span className={styles.reviewBadge}>
            {successCount} Valid / {failedCount} Error
          </span>
        </div>
      </div>

      <div className={styles.reviewBody}>
        <div className={styles.reviewTableWrap}>
          <table className={styles.reviewTable}>
            <thead>
              <tr>
                <th className={styles.rowHeader}>Row</th>
                <th>Link</th>
                <th className={styles.statusHeader}>Status</th>
              </tr>
            </thead>
            <tbody>
              {results.map((row, idx) => {
                const isFailed = row.status === "failed";
                return (
                  <tr
                    key={`${row.rowNumber}-${idx}`}
                    className={isFailed ? styles.errorRow : ""}
                  >
                    <td className={styles.rowCell}>{row.rowNumber}</td>
                    <td className={styles.linkCell}>
                      <TextWithTooltip text={row.link || "—"} limit={48} />
                      {isFailed && row.errors && row.errors.length > 0 && (
                        <div className={styles.errorDetails}>
                          <TextWithTooltip
                            text={row.errors.join(", ")}
                            limit={64}
                            textClassName={styles.errorDetailsText}
                          />
                        </div>
                      )}
                    </td>
                    <td className={styles.statusCell}>
                      {isFailed ? (
                        <span className={styles.errorStatus}>
                          <AlertCircle size={14} /> Invalid
                        </span>
                      ) : (
                        <span className={styles.readyStatus}>Ready</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
